/**
 * Prevents nested paragraphs that would break some tasks like
 * confluence importing.
 */

import { Editor, Element, Transforms, Text, type NodeEntry } from 'slate';

function preventNestedParagraphs(editor: Editor, [node, path]: NodeEntry) {
  if (!Element.isElement(node)) return false;
  if (Editor.isEditor(node)) return false;
  if (node.children.length === 0) return false;

  const parentEntry = Editor.parent(editor, path);
  if (!parentEntry) return false;

  const [parent, parentPath] = parentEntry;
  if (Editor.isEditor(parent)) return false;
  if (!Element.isElement(parent)) return false;
  if (parent.type !== 'paragraph') return false;

  const childPaths = node.children.map((_, index) =>
    Editor.pathRef(editor, [...path, index])
  );

  const pathRef = Editor.pathRef(editor, path);
  const currentNodeIndex = path[path.length - 1];
  childPaths.forEach((childPathRef, i) => {
    const { current } = childPathRef;
    if (!current) return;

    const node = Editor.node(editor, current);
    if (Text.isText(node) && node.text === '') return;

    Transforms.moveNodes(editor, {
      at: current,
      to: [...parentPath, currentNodeIndex + i],
    });
    childPathRef.unref();
  });

  if (pathRef.current) {
    Transforms.removeNodes(editor, {
      at: pathRef.current,
    });
    pathRef.unref();
  }

  return true;
}

const NestedParagraphsPlugin = {
  name: 'Nested Paragaphs Plugin',
  normalization: {
    type: 'paragraph',
    run: preventNestedParagraphs,
  },
};
export default NestedParagraphsPlugin;
